document.addEventListener("DOMContentLoaded", () => {
  const benefitsSets = document.querySelectorAll(
    ".home-product-benefits, .home-product-benefits-desktop"
  );

  benefitsSets.forEach((set) => {
    const paragraphs = set.querySelectorAll("p");
    let currentIndex = 0;

    function removeHighlight() {
      paragraphs.forEach((p) => p.classList.remove("highlight"));
    }

    function highlightParagraph(index) {
      removeHighlight();
      paragraphs[index].classList.add("highlight");
    }

    function startHighlightLoop() {
      function loop() {
        highlightParagraph(currentIndex);
        currentIndex = (currentIndex + 1) % paragraphs.length;
        setTimeout(loop, 1500);
      }
      loop();
    }

    if (paragraphs.length > 0) {
      startHighlightLoop();
    }
  });
});